import { OBJECTIVE_FIELD_TYPE } from './OBJECTIVE_FIELD_TYPE';

export class ObjectiveFieldPartTemplate {
    constructor(readonly fieldType: OBJECTIVE_FIELD_TYPE, readonly text: string) {
    }
}
